
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import vFilter from '../util/filters'
export default {
components: {
Group,
XButton
},
name: 'ProductDetail',
data () {
return {
productParams: {
productCode: '',
productId: '',
organId:''
},
productInfo:{
productUnitMin:'',
productUnitMax:'',
proRateMax:'',
loanhandingChargeMin:'',
loanhandingChargeMax:'',
recommend:''
},
productId: '',
procatId: '',
}
},
created(){

this.productParams.productCode = this.$route.query.productCode;
this.productParams.productId = this.$route.query.productId;
this.productParams.organId = this.$route.query.organId;

if (this.productParams.productCode === undefined) {
console.log('no code');
} else {
this.getProductInfo(this.productParams);
}

},
methods: {
getImage(id) {
return require(`@/assets/images/${id}.png`);
},

getProductInfo (productParams) {
const url = '/wechat/getProduct.do';
const _this = this;
this.$axios({
method: 'get',
url: url,
params: {
productCode: productParams.productCode,
productId: productParams.productId,
organId:productParams.organId
}
}).then((response) => {

if (response.data.code === 200) {
_this.productInfo = response.data.result;
_this.productId = response.data.result.productId;
_this.procatId = response.data.result.procatId;
_this.handleData();
} else {

}
}).catch(function(err){


})

},
handleApply () {
const openid = window.sessionStorage.getItem("openId");
const url = '/wechat/checkIde.do?openId='+ openid + '&productId=' + this.productId;
const _this = this;
this.$axios({
method: 'get',
url: url,
}).then((response) => {
if (response.data.code === 200) {
let result=response.data.result;
if(result.isBlack){


this.$vux.confirm.show({content: `黑名单客户不允许申请`, showCancelButton: false, confirmText: '关闭', hideOnBlur: true});
}else if(result.isReject){


this.$vux.confirm.show({content: `被拒单客户三个月不允许申请`, showCancelButton: false, confirmText: '关闭', hideOnBlur: true});
}else if(result.isRegister){
if (result.isMaxAge) {
const age = vFilter.getAge(result.isIde);

if (age && parseInt(result.isMaxAge) < parseInt(age)) {
this.$vux.confirm.show({content: `申请人年龄超过${result.isMaxAge}岁，不允许申请顺易贷产品!`, showCancelButton: false, confirmText: '关闭', hideOnBlur: true});
return;
}

}

_this.$router.push({
path: '/financingApplication',
query: {
buninessType: _this.productId,
productCode: _this.productParams.productCode,
organId:this.productParams.organId
}
});
}else{
window.sessionStorage.setItem("productDetail_productId", this.productId)
window.sessionStorage.setItem("productDetail_productCode", this.productParams.productCode)
window.sessionStorage.setItem("productDetail_organId", this.productParams.organId||'')

_this.$router.push("/register")
}

} else {

}
}).catch(function(err){


})
},
handleData () {

this.productInfo.proRateMax = this.filterMoney(this.productInfo.proRateMax);
this.productInfo.proRateMin = this.filterMoney(this.productInfo.proRateMin);
this.productInfo.loanhandingChargeMin = this.filterMoney(this.productInfo.loanhandingChargeMin);
this.productInfo.loanhandingChargeMax = this.filterMoney(this.productInfo.loanhandingChargeMax);
},

filterMoney(value) {
if (!value) return '0';
let intPart = Math.floor(value); 

let floatPart = ".00"; 
let value2Array = String(value).split(".");

if (value2Array.length == 2) {
floatPart = value2Array[1].toString(); 
if (floatPart.length == 1) { //补0,实际上用不着
return intPart + "." + floatPart + '0';
} else {
return intPart + "." + floatPart.substring(0, 2);
}
} else {
return intPart + floatPart;
}
},
}
}



// WEBPACK FOOTER //
// ./src/pages/ProductDetail.vue